import { formatDate } from "../../../../utils/DateUtils";

// O acordo é sempre com uma pessoa: aqui não existe "vale para todos" como nas regras de
// comissão. Colaborador vazio significa cadastro quebrado, e é isso que a célula diz.
const employeeRenderer = (params) => params.data?.employee?.fullName || '-';

// O percentual sozinho não diz de onde sai o dinheiro, e é justamente essa a dúvida do
// operador ao ler a listagem: o sufixo lembra que quem paga é a casa.
const percentRenderer = (params) => {
	const percent = params.data?.percent;
	return percent != null ? `${percent.toString().replace('.', ',')}% da parte da empresa` : '-';
};

// A vigência é o que permite renegociar sem reescrever o mês já fechado, então precisa estar
// legível na listagem. Sem data final, é o acordo que vale daqui para frente.
const validityRenderer = (params) => {
	const from = params.data?.validFrom;
	const to = params.data?.validTo;

	if (!from) {
		return '-';
	}

	const start = formatDate(from);
	return to ? `${start} até ${formatDate(to)}` : `Desde ${start}`;
};

// Mesma leitura da listagem de regras de comissão: separa o que está valendo hoje do que é
// histórico ou combinado para o futuro. Usa a família translúcida (`light badge-*`), a única
// com regra para o tema escuro.
const currentRenderer = (params) => {
	const isCurrent = params.data?.current === true;
	const from = params.data?.validFrom;
	const isFuture = from && new Date(from) > new Date();

	if (isCurrent) {
		return <span className="badge light badge-success">Vigente</span>;
	}
	if (isFuture) {
		return <span className="badge light badge-info">Programado</span>;
	}
	return <span className="badge light badge-dark">Encerrado</span>;
};

export const Columns = [
	{
		headerName: 'employee',
		field: 'employee.fullName',
		width: 220,
		cellRenderer: employeeRenderer,
		sortable: false
	},
	{
		headerName: 'pot_bonus_percent',
		field: 'percent',
		width: 220,
		cellRenderer: percentRenderer
	},
	{
		headerName: 'validity',
		field: 'validFrom',
		width: 220,
		cellRenderer: validityRenderer
	},
	{
		headerName: 'description',
		field: 'description',
		width: 240,
		sortable: false
	},
	{
		headerName: 'situation',
		field: 'current',
		width: 130,
		cellRenderer: currentRenderer,
		sortable: false
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		width: 120
	}
]
